import type { ReactNode } from 'react';

/**
 * 設計系統狀態膠囊（對應 docs/cms-screens 之 Component/Pill）。
 *
 * 樣式由 index.css 之 .pill / .pill--* 提供。
 */
export type PillTone = 'neutral' | 'brand' | 'success' | 'warning' | 'danger';

interface PillProps {
  tone?: PillTone;
  /** 是否顯示左側圓點 */
  dot?: boolean;
  children: ReactNode;
}

export function Pill({ tone = 'neutral', dot = true, children }: PillProps): JSX.Element {
  const cls = tone === 'neutral' ? 'pill' : `pill pill--${tone}`;
  return (
    <span className={cls}>
      {dot && <span className="pill__dot" />}
      {children}
    </span>
  );
}
